import { projectManagementApi } from '@/includes/projectManagementApi';

const pmCqiService = {
  async getProjectCqi(projectId, {
    weeks = 8,
    months = 4,
    period = 'week',
  } = {}) {
    const response = await projectManagementApi.get(`/projects/${projectId}/kpis/cqi`, {
      params: { weeks, months, period },
    });
    return response.data;
  },
};

export default pmCqiService;
